import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@material-ui/core';
import { ReactComponent as CheckedIcon } from 'Images/icons/ic_details_edit_filled_field_tick.svg';
import { ReactComponent as CheckIcon } from 'Images/icons/ic_details_edit_field_tick.svg';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import classNames from 'classnames';

const styles = theme => ({
  service: {
    padding: '0px 5px 0px 0px',
    display: 'inline-block',
    width: '100%',
    borderRadius: '4px',
    boxShadow: '0 0 75px 0 rgba(67, 73, 106, 0)',
    border: 'solid 1px rgba(151, 151, 151, 0.24)',
    backgroundColor: '#fbfbfc',
  },
  serviceChecked: {
    boxShadow: '0 0 75px 0 rgba(67, 73, 106, 0)',
    border: 'solid 1px #7ed321',
    backgroundColor: '#fbfbfc',
  },
});

const GreenCheckbox = withStyles({})(props => (
  <Checkbox
    icon={<CheckIcon />}
    checkedIcon={<CheckedIcon />}
    color="default"
    {...props}
  />
));

class ThemedCheckBox extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = () => event => {
    const { valueKey } = this.props;
    this.props.onChange(valueKey, event.target.checked);
  };

  render() {
    const { classes, checked, value } = this.props;
    return (
      <label
        className={
          checked
            ? classNames(classes.service, classes.serviceChecked)
            : classes.service
        }
      >
        <GreenCheckbox onChange={this.handleChange()} checked={checked} />
        {value}
      </label>
    );
  }
}

ThemedCheckBox.propTypes = {
  classes: PropTypes.object.isRequired,
  checked: PropTypes.bool.isRequired,
  valueKey: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

ThemedCheckBox = compose(withStyles(styles, { withTheme: true }))(
  ThemedCheckBox
);

export default ThemedCheckBox;
